import { bounds } from '@mapbox/geo-viewport'
import bboxPoly from '@turf/bbox-polygon'

export const getBoundsFromViewState = viewState => {
  const { height, width, latitude, longitude, zoom } = viewState
  const calculatedBounds = bounds([longitude, latitude], zoom, [width, height])
  return bboxPoly(calculatedBounds)
}
